(function (angular, app) {
   "use strict";
   
   // UIController
   angular.module(app.modules.ui.name)
      .controller(app.modules.ui.controllers.ui, UIController)
   
   // Injector
   UIController.$inject = ["$window", "$interval", "$timeout", "$scope" , "$location"
       , app.modules.ui.services.ui
       , app.modules.common.constants.appsettings
      , app.modules.common.services.eventbus
      , app.modules.common.services.functions
      , app.modules.member.services.detail
      , app.modules.ui.services.ui
   ];
   
   // Function
   function UIController($window, $interval, $timeout, $scope, $location
      , ggUISvc, ggSettings, ggEvents, ggFunctions, ggMember, ggUI) {
      
      // Assign control
      var ctrl = this;
      var windowSize = ggFunctions.fetchWindowSize();

       /*
      $scope.$on('$destroy', function () {
          if (angular.isDefined(invitationTimer)) {
              $interval.cancel(invitationTimer);
              invitationTimer = undefined;
          }
      });
      */

      $scope.UI = {
         isRouteChange: false
         , isShowHeading: true
         , isTouchScreen: false
         , isAuthenticated: false
         , isScroll: false
         , isProcessing: false
         , isLoaded: false
         , isConnected : false
         , isAppInstall: isCordova ? true : false
         , appVersion: ggSettings.version
         , isIOSPurchase : false
         , isInAppPurchase: false
         , isInWebPurchase: false
         , canPostScore : true
         , userAgent : ggUI.userAgent()
         , profile: {}
         , branding : app.Branding
         , windowWidth: windowSize.width
         , navigation: {
            slideIn: false
            , toggle: function () {
               if ($scope.UI.navigation.slideIn) {
                  $scope.UI.navigation.slideIn = false
               } else {
                  $scope.UI.navigation.slideIn = true;
               }
            }
            , toggleOff: function () {
               if ($scope.UI.navigation.slideIn) {
                  $scope.UI.navigation.slideIn = false;
               }
            }
            , go: function (loc) {
               $scope.UI.navigation.toggleOff();
               ggFunctions.goToPage(loc);
            }
            , back: {
               history: []
               , insert: function (path) {
                  // Add some logic her so we don't put the same path in...
                  var isHistory = false;

                  if (path != "" && path != "/" ) {
                     if ($scope.UI.navigation.back.history.length > 0) {
                        var lastPath = $scope.UI.navigation.back.history[$scope.UI.navigation.back.history.length - 1];
                        if (lastPath != path) {
                           isHistory = true;
                        }
                     } else {
                        isHistory = true;
                     }
                  } else {
                     $scope.UI.navigation.back.history = [];
                  }
                  if (isHistory) {
                     $scope.UI.navigation.back.history.push(path);
                  }

               }
               , remove: function () {
                  if ($scope.UI.navigation.back.history.length > 0){
                     ($scope.UI.navigation.back.history).splice($scope.UI.navigation.back.history.length-1, 1);
                  }
               }
               , go: function () {
                  var loc = "";
                  if ($scope.UI.navigation.back.history.length > 1) {
                     loc = $scope.UI.navigation.back.history[$scope.UI.navigation.back.history.length-2];
                  }
                  if (loc == '' || loc == '/') {
                     $scope.UI.navigation.back.history = [];
                  }

                  $scope.UI.navigation.back.remove();
                  $scope.UI.navigation.go(loc);
               }
            }
         }
         , modal: {
            login: function (data) {
               $scope.UI.navigation.toggleOff();
               ggUISvc.modal.open.login(data);
            }
         }
         , logout: function () {
            app.Member.Authenticate.Logout().then(function () {
               $scope.UI.navigation.slideIn = false;
               ggFunctions.goToPage(app.modules.view.routes.intro.path);
            });
         }
         , menu: {
            my: {
               selected: {}
               , options: []
            }
            , community: {
               selected: {}
               , options: [
                  {
                     text: 'Group Lookup',
                     value: '/group/lookup'
                  }
                  , {
                     text: 'Handicap Lookup',
                     value: '/member/lookup'
                  }
                  
               ]
            }
            , tools: {
               selected: {}
               , options: [
                  {
                     text: 'Golf Course Search',
                     value: '/course/search'
                  },
                  {
                     text: 'Course Handicap Calculator',
                     modal : "coursehandicap"
                  }

               ]
            }
            , select: function (selected) {
               if (selected.logout) {
                  $scope.UI.logout();
               } else {
                  if (selected.modal) {
                     $scope.UI.navigation.toggleOff();
                     if (selected.modal == "coursehandicap") {
                        ggUISvc.modal.open.coursehandicap();
                     }
                     if (selected.modal == "login") {
                        ggUISvc.modal.open.login();
                     }
                     if (selected.modal == "login") {
                        ggUISvc.modal.open.login();
                     }
                        
                  } else {
                     if (selected.value) {
                        if (selected.external) {
                           top.location.href = selected.value;
                        } else {
                           $scope.UI.navigation.toggleOff();
                           ggFunctions.goToPage(selected.value);
                        }
                     }
                  }
                  
               }

            }
            , updateMenu: function () {
               var options = [];
               if (app.Member.Auth.isAuthenticated) {
                   var pname = $scope.UI.profile.firstName.trim();
                   if (pname != "") {
                       pname += " ";
                   }
                   pname += $scope.UI.profile.lastName.trim();
                   if (pname == "") {
                       pname = $scope.UI.profile.networkId;
                   }

                  options.push({ text: pname , value : '/'});

                  if (app.Branding.navigationOptions.isGroupyMenu) {
                      options.push({ divider: true });
                      if ($scope.UI.canPostScore) {
                          options.push({ text: 'Post a Score', value: '/scoring/postascore' });
                      }
                      options.push({ text: 'Create a Group', value: '/group/setup' });
                      options.push({ text: 'Start an Outing', value: '/outing/setup' });
                  }
                  options.push({ divider: true });
                  if (app.Branding.navigationOptions.isPreferences) {
                      options.push({ text: 'Preferences', value: '/member/profile?pref' });
                  }
                  options.push({ text: 'Edit Profile', value: '/member/profile' });
                  options.push({ divider: true });
                  options.push({ text: 'Terms of Use & Privacy', value: '/privacy' });
                  options.push({ divider: true });

                  options.push({ text: 'Logout', logout: true, className: "redf" });
               } else {
                  options.push({ text: 'Login', modal: 'login' });
               }

               $scope.UI.menu.my.options = options;
            }
         }
        , invitations: {
            results: []
            , timer : 120000
            , fetch: function () {

                var processData = function (results) {
                    var res = [];
                    for (var i = 0; i < results.length; i++) {
                        if (results[i].groupId || results[i].outingId) {
                            res.push(results[i]);
                        }
                    }

                    $scope.UI.invitations.results = res;
                }

                if ($scope.UI.isAuthenticated) {
                    return app.Member.Network.Data.Invitations.fetch(true).then(function (data) {
                        return processData(data);
                    });
                }
            }
            , select: function (invitation) {
                ggFunctions.goToPage(app.modules.invitation.routes.invited.path + "?t=" + invitation.id);
            }
            , update: function (invitationId) {
                for (var i = 0; i < $scope.UI.invitations.results.length; i++) {
                    if ($scope.UI.invitations.results[i].id == invitationId) {
                        $scope.UI.invitations.results.splice(i, 1);
                    }
                }
            }
        }
      }

      // Set initial timer to 10 seconds, then bump to 2 minutes.
      //$timeout($scope.UI.invitations.fetch, 10000); // 10 seconds after load
      //var invitationTimer = $interval($scope.UI.invitations.fetch, $scope.UI.invitations.timer); // then every 2 minutes
      
      
      var oneSignal = {
          isLoaded: false
          , init: function () {
              var notificationOpenedCallback = function (jsonData) {
                 // console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
              };
              window.plugins.OneSignal
                .startInit(app.Branding.oneSignalId)
                .handleNotificationOpened(notificationOpenedCallback)
                .endInit();
          }
      }

       // Listeners
      // -- Route Changed
      ggEvents.subscribe("$routeChangeStart", function (event, next) {
         $scope.UI.isRouteChange = true;

         // Make this listener's code fire last, so we can check to see if event was cancelled.
         event.currentScope.$evalAsync(showLoadingPanelIfEventNotCanceled);

         function showLoadingPanelIfEventNotCanceled() {
            if (!event.defaultPrevented) {
               $scope.UI.isRouteChange = true;
            }
         }

      });
      ggEvents.subscribe("$routeChangeSuccess", function (event, next) {

         $scope.UI.isRouteChange = false;
         $scope.UI.isLoaded = true;

         if (isCordova && isCordovaReady) {
             if (!oneSignal.isLoaded) {
                 oneSignal.init();
             }
         }

      });
      ggEvents.subscribe("$locationChangeStart", function (event, next) {

         var path = $location.$$url;
         $scope.UI.navigation.back.insert(path);

      });
      ggEvents.subscribe(app.modules.common.events.toggleProcessing, function (event, data) {
         $scope.UI.isProcessing = data.isProcessing;
      });

      // Auth Change
      ggEvents.subscribe(app.modules.common.events.authChange, function () {
         $scope.UI.profile = app.Member.Detail
         $scope.UI.isAuthenticated = app.Member.Auth.isAuthenticated;

            // Can Post Score?
            if (app.Member.Detail.memberships && app.Member.Detail.memberships.length > 0) {
                var clubMembership = app.Member.Detail.memberships[0];
                if (clubMembership.club && !clubMembership.club.allowScorePosting) {
                    $scope.UI.canPostScore = false;
                }
            }

            // Handicap
            var clubMembership = {};

            if (app.Member.Detail.memberships && app.Member.Detail.memberships.length > 0) {
                clubMembership = app.Member.Detail.memberships[0];
            }
            if (clubMembership.handicaps && clubMembership.handicaps.length > 0) {
                for (var h = 0; h < clubMembership.handicaps.length; h++) {
                    var hcp = clubMembership.handicaps[h];
                    if (hcp.isOfficial) {
                        app.Member.Handicap.official = hcp;
                    }
                    if (hcp.isRealTime) {
                        app.Member.Handicap.trend = hcp;
                    }
                }
            }


         $scope.UI.menu.updateMenu();
      });
     
       // Invitation Update
      ggEvents.subscribe(app.modules.common.events.invitationUpdate, function (event, data) {
          $scope.UI.invitations.update(data.id);
      });

}   
}(angular, app));

